// extracted by mini-css-extract-plugin
module.exports = {"root":"quem-somos_root__bq-6m","title":"quem-somos_title__P9Cqv","text":"quem-somos_text__2FNno"};